/* eslint-disable no-nested-ternary */
import length from 'ramda/src/length'
import clipHandler from 'root/src/client/logic/project/handlers/clipHandler'

export default (projectAssigneesName, windowWidth) => {
	const breakpoints = [412, 360]

	// this returns array of 2 items
	// first one is clickable, second is just a text
	if (windowWidth > breakpoints[0]) {
		return length(projectAssigneesName) === 1
			? [projectAssigneesName[0], '']
			: length(projectAssigneesName) === 2
				? [clipHandler(projectAssigneesName[0], 11), ' and 1 other']
				: [clipHandler(projectAssigneesName[0], 7), ' and 2 others']
	}

	if (windowWidth > breakpoints[1]) {
		return length(projectAssigneesName) === 1
			? [projectAssigneesName[0], '']
			: length(projectAssigneesName) === 2
				? [clipHandler(projectAssigneesName[0], 8), ' and 1 other']
				: ['', `${length(projectAssigneesName)} creators`]
	}

	return length(projectAssigneesName) === 1
		? [projectAssigneesName[0], '']
		: ['', `${length(projectAssigneesName)} creators`]
}
